'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _Any = require('./rules/Any');

var _Numeric = require('./rules/Numeric');

var _String = require('./rules/String');

var _Date = require('./rules/Date');

var _Schema = require('./Schema');

var _Schema2 = _interopRequireDefault(_Schema);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var validate = function validate(values, schema) {
  if (!values) throw new Error('`values` must be supplied');
  if (!schema) throw new Error('`schema` must be supplied');
  var rawSchema = schema instanceof _Schema2.default ? schema.getSchema() : schema;
  var allErrors = {};

  for (var key in rawSchema) {
    var rules = rawSchema[key];
    var errors = void 0;

    // Number
    if (rules instanceof _Numeric.NumericRule) {
      var numericValidator = new _Numeric.NumericValidator(rules);
      errors = numericValidator.check(key, values[key]);

      // String
    } else if (rules instanceof _String.StringRule) {
      var stringValidator = new _String.StringValidator(rules);
      errors = stringValidator.check(key, values[key]);

      // Date
    } else if (rules instanceof _Date.DateRule) {
      var dateValidator = new _Date.DateValidator(rules);
      errors = dateValidator.check(key, values[key]);

      // Any (must go last since technichally all the rules are instances of AnyRule)
    } else if (rules instanceof _Any.AnyRule) {
      var anyValidator = new _Any.AnyValidator(rules);
      errors = anyValidator.check(key, values[key]);
    }

    if (errors) allErrors[key] = errors;
  }

  return _lodash2.default.get(schema, 'internals.errorHandler') ? schema.internals.errorHandler(allErrors) : allErrors;
};

exports.default = validate;